import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  createTRPCProxyClient,
  createTRPCReact,
  httpLink,
} from '@trpc/react-query';
import React, { useState } from 'react';
import { ADMIN_TRPC_URL, TRPC_URL } from '../config';
import superjson from 'superjson';
import { ExternalRouter } from '@xw-labs/bitbot-admin-backend-types';
import Decimal from 'decimal.js';
let _adminJwtToken = '';
export const setAdminJwtToken = (token: string) => {
  _adminJwtToken = token;
};
// decimal 支持
superjson.registerCustom<Decimal, string>(
  {
    isApplicable: (v): v is Decimal => Decimal.isDecimal(v),
    serialize: v => v.toJSON(),
    deserialize: v => new Decimal(v),
  },
  'decimal.js',
);

export const adminTrpc = createTRPCReact<ExternalRouter>();
export const adminTrpcApi = createTRPCProxyClient<ExternalRouter>({
  transformer: superjson,
  links: [
    httpLink({
      url: ADMIN_TRPC_URL,
      headers() {
        return {
          authorization: `Bearer ${_adminJwtToken}`,
        };
      },
    }),
  ],
});

const adminRoutes = ['spin', 'invite', 'claimReward'];

export const AdminTRPCProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { retry: false, refetchOnWindowFocus: false },
        },
      }),
  );
  const [adminTrpcClient] = useState(() =>
    adminTrpc.createClient({
      transformer: superjson,
      links: [
        // httpLink({
        //   url: ADMIN_TRPC_URL,
        //   headers() {
        //     return {
        //       authorization: `Bearer ${_adminJwtToken}`,
        //     };
        //   },
        // }),
        runtime => {
          return ctx => {
            const servers = {
              main: httpLink({
                url: TRPC_URL,
                headers() {
                  return {
                    authorization: `Bearer ${_adminJwtToken}`,
                  };
                },
              })(runtime),
              admin: httpLink({
                url: ADMIN_TRPC_URL,
                headers() {
                  return {
                    authorization: `Bearer ${_adminJwtToken}`,
                  };
                },
              })(runtime),
            };
            const pathParts = ctx.op.path.split('.');
            const path = pathParts[0];
            if (adminRoutes.includes(path)) {
              return servers.admin(ctx);
            }
            return servers.main(ctx);
          };
        },
      ],
    }),
  );

  return (
    <adminTrpc.Provider client={adminTrpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </adminTrpc.Provider>
  );
};
